import React from 'react';

function Terms() {
  return (
    <section className="services-details section-padding">
      <div className="container">
        <div className="sec-head text-left mb-80">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div>

                <div className="text">


                  <p><strong>1. Introduction</strong></p>
                  <p>Welcome to Aashway. By engaging with our services, you agree to the following terms and conditions. These terms apply to all services including Web Development, Social Media Marketing, Graphic Designing, and UI/UX Designing.</p>

                  <p><strong>2. Services Offered</strong></p>
                  <p>Aashway provides:</p>
                  <ul>
                    <li>Website Design & Development</li>
                    <li>Social Media Marketing (SMM)</li>
                    <li>Graphic Designing</li>
                    <li>UI/UX Designing</li>
                  </ul>
                  <p>Each service is delivered based on the scope discussed and agreed upon with the client.</p>

                  <p><strong>3. Payment Terms</strong></p>
                  <ul>
                    <li>A <strong>50% advance payment</strong> is required before starting any project.</li>
                    <li>The remaining <strong>50% must be paid before final delivery</strong>.</li>
                    <li>For Social Media Marketing services, <strong>100% monthly advance payment</strong> is required.</li>
                    <li>All payments are non-refundable once the work has started.</li>
                  </ul>

                  <p><strong>4. Project Scope</strong></p>
                  <ul>
                    <li>The project scope will be defined before the start of the project.</li>
                    <li>Only the agreed features, pages, and deliverables will be included.</li>
                    <li>Any additional work outside the agreed scope will be treated as a separate task and charged accordingly.</li>
                  </ul>

                  <p><strong>5. Timelines</strong></p>
                  <p>Project timelines vary depending on the complexity and requirements.</p>
                  <p>Standard timelines:</p>
                  <ul>
                    <li>Basic websites: 7–10 working days</li>
                    <li>Advanced/ecommerce websites: 10–20 working days</li>
                    <li>UI/UX Design: 5–10 working days</li>
                  </ul>
                  <p>Delays in client communication, approvals, or content submission may extend the timeline.</p>

                  <p><strong>6. Revisions Policy</strong></p>
                  <ul>
                    <li>A maximum of <strong>2 revision rounds</strong> are included in all services.</li>
                    <li>Clients are expected to provide consolidated feedback.</li>
                    <li>Additional revisions or major changes will be charged separately.</li>
                  </ul>

                  <p><strong>7. Client Responsibilities</strong></p>
                  <p>The client agrees to:</p>
                  <ul>
                    <li>Provide all required content (text, images, product details, etc.) on time</li>
                    <li>Review work and provide feedback promptly</li>
                    <li>Ensure that all materials shared do not violate any copyright or legal regulations</li>
                  </ul>

                  <p><strong>8. Third-Party Services</strong></p>
                  <ul>
                    <li>Costs related to third-party services are not included unless explicitly mentioned:</li>
                    <ul>
                      <li>Domain registration</li>
                      <li>Hosting services</li>
                      <li>Shopify subscription</li>
                      <li>Paid plugins or tools</li>
                      <li>Advertising budgets</li>
                    </ul>
                    <li>Aashway is not responsible for issues arising from third-party platforms.</li>
                  </ul>

                  <p><strong>9. Delivery & Handover</strong></p>
                  <ul>
                    <li>Final delivery will be made only after full payment is completed.</li>
                    <li>Deliverables may include:</li>
                    <ul>
                      <li>Website access</li>
                      <li>Design files</li>
                      <li>Final creatives</li>
                    </ul>
                    <li>Basic guidance may be provided upon request.</li>
                  </ul>

                  <p><strong>10. Social Media Marketing Disclaimer</strong></p>
                  <ul>
                    <li>Results such as followers, engagement, and sales depend on various external factors.</li>
                    <li>Aashway does not guarantee specific performance results.</li>
                  </ul>

                  <p><strong>11. Intellectual Property</strong></p>
                  <ul>
                    <li>Upon full payment, the client will have rights to the final delivered work.</li>
                    <li>Aashway reserves the right to showcase the project in its portfolio unless agreed otherwise.</li>
                  </ul>

                  <p><strong>12. Support & Maintenance</strong></p>
                  <ul>
                    <li>Minor support may be provided after delivery as goodwill.</li>
                    <li>Ongoing maintenance or major updates will be charged separately.</li>
                  </ul>

                  <p><strong>13. Cancellation Policy</strong></p>
                  <ul>
                    <li>Once the project has started, payments made are non-refundable.</li>
                    <li>If the client delays the project for an extended period, Aashway reserves the right to close or reschedule the project.</li>
                  </ul>

                  <p><strong>14. Limitation of Liability</strong></p>
                  <p>Aashway shall not be held liable for:</p>
                  <ul>
                    <li>Loss of data, revenue, or business</li>
                    <li>Issues caused by third-party services</li>
                    <li>Misuse of the delivered product</li>
                  </ul>

                  <p><strong>15. Updates to Terms</strong></p>
                  <p>Aashway reserves the right to update these terms at any time. Continued use of our services implies acceptance of the latest terms.</p>

                  <p><strong>16. Contact Information</strong></p>
                  <p>For any queries, contact us at:</p>
                  <p>📧 <a href="mailto:contact@aashway.in">contact@aashway.in</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Terms;
